export const fragenWelcheDokumenteBraucheIchZumAutoVerkauf = [
  {
    question: "Muss der Fahrzeugbrief beim Verkauf vorliegen?",
    answer: (
      <>
        <p>
          Ja. Ohne Fahrzeugbrief kann der Käufer das Auto nicht auf seinen Namen
          anmelden. Ist der Fahrzeugbrief noch bei der Bank, muss der Kredit
          zuerst abgelöst werden.
        </p>
      </>
    ),
  },
  {
    question: "Kann ich ein Auto ohne TÜV verkaufen?",
    answer: (
      <>
        <p>
          Ja, aber der Käufer muss den TÜV selbst neu machen. Weist du auf den
          abgelaufenen TÜV hin, kannst du dich vor Gewährleistungsansprüchen
          schützen. Der fehlende TÜV reduziert den Verkaufspreis.
        </p>
      </>
    ),
  },
  {
    question: "Reicht ein mündlicher Kaufvertrag?",
    answer: (
      <>
        <p>
          Nein. Ein schriftlicher Vertrag ist für beide Parteien rechtssicher.
          Nur so kannst du dich gegen spätere Forderungen schützen.
        </p>
      </>
    ),
  },
  {
    question: "Was passiert mit der Versicherung nach dem Verkauf?",
    answer: (
      <>
        <p>
          Die Versicherung endet erst mit der Abmeldung. Informiere daher deinen
          Versicherer und die Zulassungsstelle schriftlich über den Verkauf.
        </p>
      </>
    ),
  },
];

